// extracted by mini-css-extract-plugin
export var acceptButton = "_3g-5";
export var fullContent = "_3g-4";
export var link = "_3g-6";
export var linkIcon = "_3g-7";
export var sideContent = "_3g-3";
export var sideImage = "_3g-2";
export var sideImageWrapper = "_3g-1";
export var splitLayout = "_3g-0";